import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'nl2br'})
export class NgxExcelNl2BrPipe implements PipeTransform {

  transform(html: string): any {
    return html.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
  }

}
